<script>
  import Navbar from 'flowbite-svelte/Navbar.svelte'
  import NavContainer from 'flowbite-svelte/NavContainer.svelte'
  import NavHamburger from 'flowbite-svelte/NavHamburger.svelte'
  import NavLi from 'flowbite-svelte/NavLi.svelte'
  import NavUl from 'flowbite-svelte/NavUl.svelte'
  import SearchBar from '../routes/(landing-components)/SearchBar.svelte'
</script>

<Navbar class="bg-transparent border-b border-am-white-80">
  <NavContainer class="bg-transparent px-4 md:px-20">
    <div class="flex flex-nowrap flex-auto">
      <a href="/" class="flex justify-center items-center gap-2">
        <img src="/blue.png" alt="AddMeetings Logo" class="w-8 md:w-10" />
        <span class="text-am-blue text-xl md:text-xl !font-semibold">AddMeetings</span>
      </a>
    </div>

    <div class="flex sm:order-2">
      <NavHamburger class="block md:hidden" />
    </div>
    <NavUl
      ulClass="flex flex-col justify-center md:justify-between py-2.5 px-4 mt-4 md:flex-row md:space-x-16 md:space-x-20 xl:space-x-32 rtl:space-x-reverse sm:mt-0 sm:text-sm sm:font-medium text-center"
    >
      <!-- Search Bar - visible on mobile/tablet -->
      <div class="lg:hidden mb-4 md:mb-0">
        <SearchBar />
      </div>

      <div class="flex flex-1 gap-10">
        <!-- Navigation Links -->
        <div class="flex flex-col md:flex-row md:items-center gap-2 sm:gap-4 md:gap-8">
          <NavLi class="md:py-2 whitespace-nowrap" href="/about">About</NavLi>
          <NavLi class="md:py-2 whitespace-nowrap" href="/for-buyers">For Buyers</NavLi>
          <NavLi class="md:py-2 whitespace-nowrap" href="/for-sales">For Sales</NavLi>
          <NavLi class="md:py-2 whitespace-nowrap" href="https://blog.addmeetings.com/">Blog</NavLi>
        </div>

        <!-- Search Bar - visible on desktop -->
        <div class="hidden lg:flex flex-1 mx-8">
          <SearchBar />
        </div>
      </div>

      <!-- Authentication Buttons -->
      <div class="flex flex-col md:flex-row items-center gap-2 md::gap-5 mt-4 md:mt-0 md:ml-8">
        <a
          class="flex items-center justify-center gap-2 bg-[#536aff] text-white hover:text-white px-4 py-2 rounded-full hover:hover:bg-[#4444ff] md:hover:bg-[#4444ff] md:hover:text-white transition-colors font-semibold w-fit"
          href="https://app.addmeetings.com/register"
        >
          Register
          <span class="material-symbols-rounded" style="font-size: 20px; font-variation-settings: 'FILL' 0, 'wght' 300;"
            >arrow_forward</span
          >
        </a>
        <a
          class="py-2 px-4 rounded-full border-[1.5px] !font-semibold border-am-white-60 hover:border-am-blue-20 hover:text-am-blue transition duration-300 ease-in-out w-fit whitespace-nowrap"
          href="https://app.addmeetings.com/login"
        >
          Log in
        </a>
      </div>
    </NavUl>
  </NavContainer>
</Navbar>
